import React from "react";
import { useHistory } from "react-router-dom";

const Submenu = ({ value }) => {
  const { categoryId, category, product } = value;
  const history = useHistory();

  return (
    <section className="mx-4 mt-40 md:mx-12 md:mt-52 lg:mt-48">
      <div className="flex justify-between items-center bg-white/70 backdrop-blur-md p-4 md:p-5 lg:p-6 rounded-2xl shadow-sm border border-gray-300">
        <nav className="flex items-center text-xs md:text-sm lg:text-base space-x-2 text-gray-700 font-light tracking-wide">
          <span
            className="hover:text-black transition-colors duration-200 cursor-pointer"
            onClick={() => history.push("/")}>
            FlitzStoreBR
          </span>
          <span className="text-gray-400">/</span>
          <span
            className="hover:text-black transition-colors duration-200 cursor-pointer"
            onClick={() => history.push(`/products/category/${categoryId}`)}>
            {category}
          </span>
          <span className="text-gray-400">/</span>
          <span className="text-black font-medium">{product}</span>
        </nav>

        <svg
          className="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.5}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 5l7 7-7 7M5 5l7 7-7 7"
          />
        </svg>
      </div>
    </section>
  );
};

export default Submenu;